import { Component, OnInit } from '@angular/core';
import { CommonFunctionService } from '../../services/common-function.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbDropdownModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ApiRequestsService } from '../../services/api-requests.service';
import { Router } from '@angular/router';
import { DataManipulateService } from '../../services/data-manipulate.service';

@Component({
  selector: 'app-default-header',
  templateUrl: './default-header.component.html',
  styleUrls: ['./default-header.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, NgbModule, NgbDropdownModule],
})
export class DefaultHeaderComponent implements OnInit {

  constructor(public common: CommonFunctionService, private api: ApiRequestsService, private router: Router, public dmService: DataManipulateService) { }
  ngOnInit(): void {

  }

  toggle() {
    document.body.classList.toggle('sidebar-lg-show');
  }

  logout() {
    this.api.updateOrSetTokenValue('');
    this.dmService.userInfo = {};
    this.router.navigateByUrl('/login');
  }

  goToProfile() {
    this.router.navigateByUrl('/profile');
  }

  goToChangePassword() {
    this.router.navigateByUrl('/change-password');
  }

}
